<template>
  <div class="button-edit" @click="onClick">
    <v-btn icon small>
      <v-icon :size="size === 'large' ? '22' : '13'" color="primary"
        >fas fa-pen</v-icon
      >
    </v-btn>
    <span
      :class="[size === 'large' ? 'text-md-subtitle-2 body-2' : 'caption']"
      class="primary--text"
    >
      {{ text }}</span
    >
  </div>
</template>
<script>
export default {
  name: "ButtonEdit",
  props: {
    size: {},
    text: {
      type: String,
      default: '',
    },
  },
  data: () => ({}),
  computed: {},
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
.button-edit {
  cursor: pointer;
  user-select: none;
}
</style>